import BlueCargoRoundLogo from 'components/BlueCargoRoundLogo';
import React from 'react';
import BCBrandingFooter from '../BCBrandingFooter';

interface Props {
  classes: Record<string, string>;
  hideFooter?: boolean;
  showLogo?: boolean;
  children?: React.ReactNode;
}

const InformationPage: React.FC<Props> = (props) => {
  const { classes, children, hideFooter, showLogo } = props;

  return (
    <div className={classes.container}>
      <div className={classes.background} />
      <div className={classes.smog} />
      <div className={classes.gradient} />
      <div className={classes.colorFilter} />

      {showLogo && <BlueCargoRoundLogo className="pt-4 z-10" />}

      <div className={classes.content}>{children}</div>
      {!hideFooter && (
        <BCBrandingFooter
          classes={{ footer: classes.footer }}
          termsOfUseUri="/terms-of-use/"
          privacyPolicy="/privacy-policy/"
        />
      )}
    </div>
  );
};
InformationPage.displayName = 'InformationPage';

export default InformationPage;
